import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey:            "AIzaSyBr2qkgi8akGKzJdTSjhZMJ6q_UpoIekxI",
  authDomain:        "bethesda-espanol.firebaseapp.com",
  databaseURL:       "https://bethesda-espanol-default-rtdb.firebaseio.com",
  projectId:         "bethesda-espanol",
  storageBucket:     "bethesda-espanol.firebasestorage.app",
  messagingSenderId: "511165868474",
  appId:             "1:511165868474:web:553cc101b8b7d15b6c1583",
  measurementId:     "G-6Y8WGSXWK4",
};

const app                   = initializeApp(firebaseConfig);
export const db             = getFirestore(app);
export const auth           = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Messaging — only works in browsers that support service workers
let messaging = null;
try {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator && 'Notification' in window) {
    messaging = getMessaging(app);
  }
} catch (e) {
  messaging = null;
}
export { messaging, getToken, onMessage };

export const VAPID_KEY = 'BPoFmi75jpHcfBJM6Y3XcgSVbTlb0cDKWrxDao4NljS3GPE7bDnpgATmZbjjBphsqYuxFcumPs7kqW8M-clDM5c';

export default app;
